import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import ClientBodyTestsService from "../../../../../../services/bodyTests/ClientBodyTestsService";

type Props = {
    testId: string;
    onTestOptionDelete: (testId: string) => void;
    closeModal: () => void;
    t: any;
};

class OptionsDelete extends Component<Props> {
    handleDelete = async () => {
        const { testId, onTestOptionDelete, closeModal, t } = this.props;
        const confirmMsg = t("buttons.delete_confirm");

        if (window.confirm(confirmMsg)) {
            try {
                await ClientBodyTestsService.deleteClientBodyTest(testId);
                onTestOptionDelete(testId); // <- usunięcie z listy
                closeModal();
            } catch (error) {
                console.error("Delete error:", error);
            }
        }
    };

    render() {
        const { t } = this.props;
        return (
            <div className="center">
                <button onClick={this.handleDelete} className="buttonDelete">
                    {t("buttons.delete")}
                </button>
            </div>
        );
    }
}

export default withTranslation("global")(OptionsDelete);
